import { useState, useEffect } from "react";
import SupportsAPI from "../../../../api/SupportsAPI";

const useFetchTickets = () => {
	const [loading, setLoading] = useState(false);
	const [tickets, setTickets] = useState([]);

	const fetchTickets = async () => {
		setLoading(true);
		try {
			const result = await SupportsAPI.getAllTickets();
			setTickets(formatPreprocess(result));
		} catch (error) {
			console.error("Failed to fetch tickets:", error);
			setTickets([]);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	const formatPreprocess = (data) => {
		if (data && Array.isArray(data)) {
			return data.map(({ ticket, messages, history }) => {
				const firstMessage = messages[0] ?? null;

				return {
					id: ticket.id,
					ticketId: ticket.ticket_number,
					subject: ticket.subject,
					category: ticket.category,
					submittedByName: ticket?.submitted_by?.name ?? "Unknown",
					submittedByRole: ticket?.submitted_by?.role ?? "Other",
					dateSubmitted: ticket.created_at,
					status: ticket.status,
					submittedBy: ticket.submitted_by,
					messages,
					history,
				};
			});
		} else {
			return [];
		}
	};

	useEffect(() => {
		fetchTickets();
	}, []);

	return {
		tickets,
		loading,
		refetch: fetchTickets,
	};
};

export default useFetchTickets;
